<template>
  <div>
    <div class="bottom-line" v-if="page <= 6">
      <img :src="path+('bottom-line.png')">
    </div>
    <!--假牙問題-->
    <div class="test-p1 rd-test" v-if="page <= 6">
      <div class="card-area"
           @mousedown="handleMouseDown"
           @mouseup="handleMouseUp"
           @mousemove="handleMouseMove"
           @touchstart="handleTouchStart"
           @touchend="handleTouchEnd">
        <!--點擊yes就給yes no就給no 點擊同時下一張要加上now-->
        <div class="card-item t1pic1 firstcard" v-bind:class="{yes: answers[0].answer === true,no: answers[0].answer === false}">
          <div class="rel-formove">
            <div class="shadow-area"></div>
            <div class="yes-mark">
                <img :src="path+('cry-1.gif')">
            </div>
            <div class="no-mark">
                <img :src="path+('smile-1.gif')">
            </div>
              <div class="full-mask"></div>
              <div class="ribbon-title">
                <div class="left-area">
                  <div class="num-title">
                    <img :src="path+('Q1.svg')">
                  </div>
                  <h2>
                    拒絕湯圓、麻糬等黏牙食物
                  </h2>
                </div>
                <div class="arrsvg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
                    <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#00A64C"/>
                  </svg>
                </div>
              </div>
          </div>
        </div>
        <div class="card-item t1pic2" v-bind:class="{now: page === 2 || page === 3, yes: answers[1].answer === true,no: answers[1].answer === false}">
            <div class="rel-formove">
                <div class="shadow-area"></div>
                <div class="yes-mark">
                    <img :src="path+('cry-2.gif')">
                </div>
                <div class="no-mark">
                    <img :src="path+('smile-2.gif')">
                </div>
              <div class="full-mask"></div>
              <div class="ribbon-title">
                <div class="left-area">
                  <div class="num-title">
                    <img :src="path+('Q2.svg')">
                  </div>
                  <h2>
                    怕假牙不穩當，不吃偏硬的食物
                  </h2>
                </div>
                <div class="arrsvg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
                    <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#00A64C"/>
                  </svg>
                </div>
              </div>
            </div>
        </div>
        <div class="card-item t1pic3" v-bind:class="{now: page === 3 || page === 4, yes: answers[2].answer === true,no: answers[2].answer === false}">
            <div class="rel-formove">
                <div class="shadow-area"></div>
                <div class="yes-mark">
                    <img :src="path+('cry-3.gif')">
                </div>
                <div class="no-mark">
                    <img :src="path+('smile-3.gif')">
                </div>
              <div class="full-mask"></div>
              <div class="ribbon-title">
                <div class="left-area">
                  <div class="num-title">
                    <img :src="path+('Q3.svg')">
                  </div>
                  <h2>
                    擔心講話假牙飄出異味
                  </h2>
                </div>
                <div class="arrsvg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
                    <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#00A64C"/>
                  </svg>
                </div>
              </div>
            </div>
        </div>
        <div class="card-item t1pic4" v-bind:class="{now: page === 4 || page === 5, yes: answers[3].answer === true,no: answers[3].answer === false}">
            <div class="rel-formove">
                <div class="shadow-area"></div>
                <div class="yes-mark">
                    <img :src="path+('cry-4.gif')">
                </div>
                <div class="no-mark">
                    <img :src="path+('smile-4.gif')">
                </div>
              <div class="full-mask"></div>
              <div class="ribbon-title">
                <div class="left-area">
                  <div class="num-title">
                    <img :src="path+('Q4.svg')">
                  </div>
                  <h2>
                    擔心講話或大笑，假牙會飛出
                  </h2>
                </div>
                <div class="arrsvg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
                    <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#00A64C"/>
                  </svg>
                </div>
              </div>
            </div>
        </div>
        <div class="card-item t1pic5" v-bind:class="{now: page === 5 || page === 6, yes: answers[4].answer === true,no: answers[4].answer === false}">
            <div class="rel-formove">
                <div class="shadow-area"></div>
                <div class="yes-mark">
                    <img :src="path+('cry-5.gif')">
                </div>
                <div class="no-mark">
                    <img :src="path+('smile-5.gif')">
                </div>
              <div class="full-mask"></div>
              <div class="ribbon-title">
                <div class="left-area">
                  <div class="num-title">
                    <img :src="path+('Q5.svg')">
                  </div>
                  <h2>
                    清潔假牙，我都用漱口水漱一漱
                  </h2>
                </div>
                <div class="arrsvg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
                    <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#00A64C"/>
                  </svg>
                </div>
              </div>
            </div>
        </div>
        <div class="card-item t1pic6" v-bind:class="{now: page === 6 || page === 7, yes: answers[5].answer === true,no: answers[5].answer === false}">
            <div class="rel-formove">
                <div class="shadow-area"></div>
                <div class="yes-mark">
                    <img :src="path+('cry-6.gif')">
                </div>
                <div class="no-mark">
                    <img :src="path+('smile-6.gif')">
                </div>
              <div class="full-mask"></div>
              <div class="ribbon-title">
                <div class="left-area">
                  <div class="num-title">
                    <img :src="path+('Q6.svg')">
                  </div>
                  <h2>
                    假牙跟真牙一樣，沾牙膏刷一刷就好
                  </h2>
                </div>
                <div class="arrsvg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
                    <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#00A64C"/>
                  </svg>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div class="page-num">
        <p v-text="page">1</p>
        <span>/</span>
        <p>6</p>
      </div>
      <div class="yn-btn-area">
        <button class="nobtn" v-on:click="selectAnswer(false)">
          <img :src="path+('NOg.svg')">
        </button>
        <button class="yesbtn" v-on:click="selectAnswer(true)">
          <img :src="path+('YESg.svg')">
        </button>
      </div>
    </div>

    <!--假牙結果1 兩星-->
    <div class="resbg rd-result" v-if="star === 2">
      <div class="mask-green"></div>
      <div class="content-area">
        <div class="top-pad12">
          <div class="kv">
            <img :src="path+('resp1-1.png')">
          </div>
          <div class="feature-box">
            <img :src="path+('ficon1.svg')">
            <p>太黏、太硬 都不行！<br>
              又覺得假牙有異味？</p>
            <img :src="path+('ficon2.svg')">
          </div>
          <div class="main-title">
            <img :src="path+('main-title1.svg')">
          </div>
        </div>
        <div class="pr-are">
          <div class="border-box ">
            <div class="titlebox">
              <img :src="path+('titletip1.png')">
            </div>
            <h3 class="col-green">
              你需要最可靠的穩當+清潔幫手，<br>
              大力助攻、才能有助於提升吃貨潛力！
            </h3>
            <ul class="pr-list">
              <li>
                <div class="pr-box">
                  <img :src="path+('pr1.png')">
                </div>
                <p>
                  穩當問題交給 <span class="col-green">保麗淨假牙黏著劑</span>，獨特氣墊緩衝技術、每口美食都穩當當！
                </p>
              </li>
              <li>
                <div class="pr-box">
                  <img :src="path+('pr2.png')">
                </div>
                <p>
                  異味則需要<span class="col-green">保麗淨假牙清潔錠</span>，有效減少假牙上的異味細菌孳生！
                </p>
              </li>
            </ul>
            <div class="flex-center">
              <a class="share-result col-green" v-on:click="share(path+('Share_假牙問題_score_20-3.png'))">
                <img :src="path+('txt-result.svg')">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                  <path d="M15 10.3937L6 15.5898L6 5.19751L15 10.3937Z" fill="white"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="statement">
        如對產品有任何問題，請直接聯繫保麗淨消費者服務專線 0800-212-259。 使用前詳閱包裝外盒說明、警語及注意事項 北市衛器廣字第113030174號、衛署醫器輸壹字第001416號 保麗淨假牙黏著劑(未滅菌)、衛署醫器輸壹字第002055號保麗淨假牙清潔錠(未滅菌)、英商葛蘭素史克消費保健用品股份有限公司台灣分公司 台北市忠孝西路一段66號24樓 Trademarks owned by or licensed to Haleon group of companies. ©2024 Haleon group of companies or its licensor. PM-TW-POLD-24-00033
      </div>
      <div class="othertest bluebg">
        <div class="flex-area">
          <img class="peo" :src="path+('doc1.svg')">
          <div class="right-area">
            <div class="top-flex">
              <img :src="path+('lampicon.svg')">
              <h3>真牙照顧也很重要！</h3>
            </div>
            <a href="javascript:void ('')" class="link-btn" v-on:click="switchMouthTest">
              <img :src="path+('btnfont1.svg')">

              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M15 10.3937L6 15.5898L6 5.19751L15 10.3937Z" fill="#808080"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!--假牙結果2 三星-->
    <div class="resbg rd-result" v-if="star === 3">
      <div class="mask-green"></div>
      <div class="content-area">
        <div class="top-pad12">
          <div class="kv">
            <img :src="path+('resp1-2.png')">
          </div>
          <div class="feature-box">
            <img :src="path+('ficon1.svg')">
            <p>黏、硬食物，假牙扛不住！<br>
              又擔心異味？</p>
            <img :src="path+('ficon2.svg')">
          </div>
          <div class="main-title">
            <img :src="path+('main-title2.svg')">
          </div>
        </div>
        <div class="pr-are">
          <div class="border-box ">
            <div class="titlebox">
              <img :src="path+('titletip1.png')">
            </div>
            <h3 class="col-green">
              想繼續當美食獵人、吃貨潛力值快補強，
              選用穩當清潔兩幫手，一次補齊戰鬥力！
            </h3>
            <ul class="pr-list">
              <li>
                <div class="pr-box">
                  <img :src="path+('pr1.png')">
                </div>
                <p>
                  加強穩當請使用<span class="col-green">保麗淨假牙黏著劑</span>，獨特氣墊緩衝技術、各種美食都穩當咬！
                </p>
              </li>
              <li>
                <div class="pr-box">
                  <img :src="path+('pr2.png')">
                </div>
                <p>
                  去除異味則須<span class="col-green">保麗淨假牙清潔錠</span>，有效降低假牙上異味細菌殘留！
                </p>
              </li>
            </ul>
            <div class="flex-center">
              <a class="share-result col-green" v-on:click="share(path+('Share_假牙問題_score_20-2.png'))">
                <img :src="path+('txt-result.svg')">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                  <path d="M15 10.3937L6 15.5898L6 5.19751L15 10.3937Z" fill="white"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="statement">
        如對產品有任何問題，請直接聯繫保麗淨消費者服務專線 0800-212-259。 使用前詳閱包裝外盒說明、警語及注意事項 北市衛器廣字第113030174號、衛署醫器輸壹字第001416號 保麗淨假牙黏著劑(未滅菌)、衛署醫器輸壹字第002055號保麗淨假牙清潔錠(未滅菌)、英商葛蘭素史克消費保健用品股份有限公司台灣分公司 台北市忠孝西路一段66號24樓 Trademarks owned by or licensed to Haleon group of companies. ©2024 Haleon group of companies or its licensor. PM-TW-POLD-24-00033
      </div>
      <div class="othertest bluebg">
        <div class="flex-area">
          <img class="peo" :src="path+('doc1.svg')">
          <div class="right-area">
            <div class="top-flex">
              <img :src="path+('lampicon.svg')">
              <h3>真牙照顧也很重要！</h3>
            </div>
            <a href="javascript:void ('')" class="link-btn" v-on:click="switchMouthTest">
              <img :src="path+('btnfont1.svg')">

              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M15 10.3937L6 15.5898L6 5.19751L15 10.3937Z" fill="#808080"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!--假牙結果3 四星-->
    <div class="resbg rd-result" v-if="star === 4">
      <div class="mask-green"></div>
      <div class="content-area">
        <div class="top-pad12">
          <div class="kv">
            <img :src="path+('resp1-3.png')">
          </div>
          <div class="feature-box">
            <img :src="path+('ficon1.svg')">
            <p>太硬、太黏食物會怕，<br>
              一有異味就想刷假牙？</p>
            <img :src="path+('ficon2.svg')">
          </div>
          <div class="main-title">
            <img :src="path+('main-title3.svg')">
          </div>
        </div>
        <div class="pr-are">
          <div class="border-box ">
            <div class="titlebox">
              <img :src="path+('titletip1.png')">
            </div>
            <h3 class="col-green">
              你距離吃貨只差一點點距離，<br>
              持續兼顧穩當與清潔，激發吃貨潛力！
            </h3>
            <ul class="pr-list">
              <li>
                <div class="pr-box">
                  <img :src="path+('pr1.png')">
                </div>
                <p>
                  <span class="col-green">保麗淨假牙黏著劑</span>，支持穩當咬，獨特氣墊緩衝技術、牙齦好舒適～
                </p>
              </li>
              <li>
                <div class="pr-box">
                  <img :src="path+('pr2.png')">
                </div>
                <p>
                  <span class="col-green">保麗淨假牙清潔錠</span>，有效清潔卻又不刮傷假牙！
                </p>
              </li>
            </ul>
            <div class="flex-center">
              <a class="share-result col-green" v-on:click="share(path+('Share_假牙問題_score_20-1.png'))">
                <img :src="path+('txt-result.svg')">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                  <path d="M15 10.3937L6 15.5898L6 5.19751L15 10.3937Z" fill="white"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="statement">
        如對產品有任何問題，請直接聯繫保麗淨消費者服務專線 0800-212-259。 使用前詳閱包裝外盒說明、警語及注意事項 北市衛器廣字第113030174號、衛署醫器輸壹字第001416號 保麗淨假牙黏著劑(未滅菌)、衛署醫器輸壹字第002055號保麗淨假牙清潔錠(未滅菌)、英商葛蘭素史克消費保健用品股份有限公司台灣分公司 台北市忠孝西路一段66號24樓 Trademarks owned by or licensed to Haleon group of companies. ©2024 Haleon group of companies or its licensor. PM-TW-POLD-24-00033
      </div>
      <div class="othertest bluebg">
        <div class="flex-area">
          <img class="peo" :src="path+('doc1.svg')">
          <div class="right-area">
            <div class="top-flex">
              <img :src="path+('lampicon.svg')">
              <h3>真牙照顧也很重要！</h3>
            </div>
            <a href="javascript:void ('')" class="link-btn" v-on:click="switchMouthTest">
              <img :src="path+('btnfont1.svg')">

              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M15 10.3937L6 15.5898L6 5.19751L15 10.3937Z" fill="#808080"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!--假牙結果4 五星-->
    <div class="resbg rd-result" v-if="star === 5">
      <div class="mask-green"></div>
      <div class="content-area">
        <div class="top-pad12">
          <div class="kv">
            <img :src="path+('resp1-4.png')">
          </div>
          <div class="feature-box">
            <img :src="path+('ficon3.svg')">
            <p>多硬、多黏都穩當咬，<br> 也不怕異味！</p>
            <img :src="path+('ficon2.svg')">
          </div>
          <div class="main-title">
            <img :src="path+('main-title4.svg')">
          </div>
        </div>
        <div class="pr-are">
          <div class="border-box ">
            <div class="titlebox">
              <img :src="path+('titletip1.png')">
            </div>
            <h3 class="col-green">
              想要持續勝任吃貨冠軍，<br>
              穩當、清潔缺一不可！
            </h3>
            <ul class="pr-list">
              <li>
                <div class="pr-box">
                  <img :src="path+('pr1.png')">
                </div>
                <p>
                  <span class="col-green">保麗淨假牙黏著劑</span>，獨特氣墊緩衝技術、怎麼吃都穩當咬！
                </p>
              </li>
              <li>
                <div class="pr-box">
                  <img :src="path+('pr2.png')">
                </div>
                <p>
                  <span class="col-green">保麗淨假牙清潔錠</span>，持續幫助全面清潔且不傷假牙！
                </p>
              </li>
            </ul>
            <div class="flex-center">
              <a class="share-result col-green" v-on:click="share(path+('Share_假牙問題_score_20.png'))">
                <img :src="path+('txt-result.svg')">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                  <path d="M15 10.3937L6 15.5898L6 5.19751L15 10.3937Z" fill="white"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="statement">
        如對產品有任何問題，請直接聯繫保麗淨消費者服務專線 0800-212-259。 使用前詳閱包裝外盒說明、警語及注意事項 北市衛器廣字第113030174號、衛署醫器輸壹字第001416號 保麗淨假牙黏著劑(未滅菌)、衛署醫器輸壹字第002055號保麗淨假牙清潔錠(未滅菌)、英商葛蘭素史克消費保健用品股份有限公司台灣分公司 台北市忠孝西路一段66號24樓 Trademarks owned by or licensed to Haleon group of companies. ©2024 Haleon group of companies or its licensor. PM-TW-POLD-24-00033
      </div>
      <div class="othertest bluebg">
        <div class="flex-area">
          <img class="peo" :src="path+('doc1.svg')">
          <div class="right-area">
            <div class="top-flex">
              <img :src="path+('lampicon.svg')">
              <h3>真牙照顧也很重要！</h3>
            </div>
            <a href="javascript:void ('')" class="link-btn" v-on:click="switchMouthTest">
              <img :src="path+('btnfont1.svg')">

              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M15 10.3937L6 15.5898L6 5.19751L15 10.3937Z" fill="#808080"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

  import {gsap} from "gsap";
  import Vue from "vue";

  export default {
    props: ["path", "show_retainer"],
    name:"DenturesTest",
    data() {
      return {
        page:1,
        answers:[
          {
            answer:null,
          },
          {
            answer:null,
          },
          {
            answer:null,
          },
          {
            answer:null,
          },
          {
            answer:null,
          },
          {
            answer:null,
          }
        ],
        star:0,
          touch:{
            enable:true,
            startX: 0,
            currentX: 0,
          }
      }
    },
    methods: {
        handleTouchStart(event) {
            this.touch.startX = event.touches[0].clientX;
        },
        handleTouchEnd(event) {
            let endX = event.changedTouches[0].clientX;
            this.detectDirection(endX - this.touch.startX);
        },
        handleMouseDown(event) {
            this.touch.startX = event.clientX;
            window.addEventListener('mousemove', this.handleMouseMove);
        },
        handleMouseMove(event) {
            this.touch.currentX = event.clientX;
        },
        handleMouseUp(event) {
            window.removeEventListener('mousemove', this.handleMouseMove);
            this.detectDirection(this.touch.currentX - this.touch.startX);
        },
        detectDirection(distance) {
            const threshold = 20;

            if(this.touch.enable){
                if (distance > threshold) {
                    this.touch.enable = false
                    this.touch.startX = 0
                    this.touch.currentX = 0
                    this.selectAnswer(true)
                } else if (distance < -threshold) {
                    this.touch.enable = false
                    this.touch.startX = 0
                    this.touch.currentX = 0
                    this.selectAnswer(false)
                }
            }
        },
      share(url){
        this.$emit('share', url)
      },
      switchMouthTest(){
        let _this = this
        gsap.to('.rd-result',{opacity:0, duration:.5, onComplete:function () {
            _this.$emit('switch-component', 'mouth-test')
            _this.$emit('close-retainer-test')
            _this.$emit('close-result')
          }})
      },
      selectAnswer(answer){

        const _this = this
        this.answers[this.page-1].answer = answer
        this.page++

        if(this.page === 7){
            this.showResult()
        }
        setTimeout(function () {
            _this.touch.enable = true
        }, 1000)
      },
      showResult(){
        let _this = this

        gsap.to('.rd-test',{opacity:0, duration:.3, onComplete:function () {
            _this.$emit('open-result')

            let count = _this.answers.filter(item => item.answer === true).length;

            if(count === 0){
              _this.star = 5
            }else if(count === 1 || count === 2){
              _this.star = 4
            }else if(count === 3 || count === 4){
              _this.star = 3
            }else if(count === 5 || count === 6){
              _this.star = 2
            }
            Vue.nextTick(function () {
              gsap.to('.rd-result',{opacity:1, duration:.3})
            })
          }})
      }
    },
    mounted(){
      gsap.to('.rd-test',{opacity:1, duration:.5})
    }
  }
</script>

